import { CamerasDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAdminTenantCameras(
  tenantId: string,
  includeImage = true,
  enabled = true
) {
  const params = new URLSearchParams();
  if (includeImage) params.set('includeImage', 'true');
  const qs = params.toString();
  const url = `/v2/orm/admin/tenants/${tenantId}/cameras${qs ? `?${qs}` : ''}`;
  const request = new Request(url);

  return useAuthenticatedRequest<CamerasDTO>(request, {
    // Prefix with 'cameras' so existing camera mutations
    // (vehicle/mask-deadzone toggles) invalidate this query too.
    queryKey: ['cameras', 'admin-tenant', tenantId, { includeImage }],
    enabled,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useAdminTenantCameras;
